export const getActionFromPath = (pathname: string): string => {
  switch (pathname) {
    case "/warehouse-config/create-warehouse-in-ward":
      return "CREATE";
    case "/warehouse-config/edit-warehouse-in-ward":
      return "EDIT";
    case "/warehouse-config/detail-warehouse-in-ward":
      return "DETAIL";
    default:
      return "";
  }
};
